// Generated by purs version 0.15.15
import * as Control_Applicative from "../Control.Applicative/index.js";
import * as Control_Applicative_Extra from "../Control.Applicative.Extra/index.js";
import * as Control_Apply from "../Control.Apply/index.js";
import * as Control_Bind from "../Control.Bind/index.js";
import * as Control_Category from "../Control.Category/index.js";
import * as Control_Monad_Reader_Class from "../Control.Monad.Reader.Class/index.js";
import * as Data_Eq from "../Data.Eq/index.js";
import * as Data_Foldable from "../Data.Foldable/index.js";
import * as Data_Function from "../Data.Function/index.js";
import * as Data_Functor from "../Data.Functor/index.js";
import * as Data_Functor_Invariant from "../Data.Functor.Invariant/index.js";
import * as Data_HeytingAlgebra from "../Data.HeytingAlgebra/index.js";
import * as Data_Maybe from "../Data.Maybe/index.js";
import * as Data_Monoid from "../Data.Monoid/index.js";
import * as Data_Semigroup from "../Data.Semigroup/index.js";
import * as Data_Tuple from "../Data.Tuple/index.js";
import * as Data_Unit from "../Data.Unit/index.js";
import * as Effect_Class from "../Effect.Class/index.js";
import * as Foreign_Object from "../Foreign.Object/index.js";
import * as Record from "../Record/index.js";
import * as Restaumatic_Prelude_Specular from "../Restaumatic.Prelude.Specular/index.js";
import * as Specular_Callback from "../Specular.Callback/index.js";
import * as Specular_DeprecatedDontUse_Input from "../Specular.DeprecatedDontUse.Input/index.js";
import * as Specular_Dom_Browser from "../Specular.Dom.Browser/index.js";
import * as Specular_Dom_Builder from "../Specular.Dom.Builder/index.js";
import * as Specular_Dom_Builder_Class from "../Specular.Dom.Builder.Class/index.js";
import * as Specular_Dom_Element from "../Specular.Dom.Element/index.js";
import * as Specular_Dom_Extra from "../Specular.Dom.Extra/index.js";
import * as Specular_Dom_Widget from "../Specular.Dom.Widget/index.js";
import * as Specular_Extra_Attr from "../Specular.Extra.Attr/index.js";
import * as Specular_FRP_Async from "../Specular.FRP.Async/index.js";
import * as Specular_FRP_Base from "../Specular.FRP.Base/index.js";
import * as Specular_FRP_Replaceable from "../Specular.FRP.Replaceable/index.js";
import * as Specular_Ref from "../Specular.Ref/index.js";
import * as Type_Proxy from "../Type.Proxy/index.js";
import * as Utils_DynamicFixFRP from "../Utils.DynamicFixFRP/index.js";
var bind = /* #__PURE__ */ Control_Bind.bind(Specular_Dom_Builder.bindBuilder);
var discard = /* #__PURE__ */ Control_Bind.discard(Control_Bind.discardUnit);
var discard1 = /* #__PURE__ */ discard(Specular_Dom_Builder.bindBuilder);
var liftEffect = /* #__PURE__ */ Effect_Class.liftEffect(Specular_Dom_Builder.monadEffectBuilder);
var newEvent = /* #__PURE__ */ Specular_FRP_Base.newEvent(Specular_Dom_Builder.monadEffectBuilder);
var monadFRP = /* #__PURE__ */ Specular_FRP_Base.monadFRP(Specular_Dom_Builder.monadEffectBuilder)(Specular_Dom_Builder.monadCleanupBuilder);
var onDomEvent = /* #__PURE__ */ Specular_Dom_Builder_Class.onDomEvent(monadFRP);
var liftEffect1 = /* #__PURE__ */ Effect_Class.liftEffect(Effect_Class.monadEffectEffect);
var pure = /* #__PURE__ */ Control_Applicative.pure(Specular_Dom_Builder.applicativeBuilder);
var pure1 = /* #__PURE__ */ Control_Applicative.pure(Specular_FRP_Base.applicativeDynamic);
var rawHtml = /* #__PURE__ */ Specular_Dom_Builder_Class.rawHtml(Specular_Dom_Builder.monadDomBuilderBuilder);
var dynamic_ = /* #__PURE__ */ Specular_FRP_Replaceable.dynamic_(Specular_Dom_Builder.monadReplaceBuilder)(monadFRP);
var mapFlipped = /* #__PURE__ */ Data_Functor.mapFlipped(Specular_FRP_Base.functorDynamic);
var uniqDyn = /* #__PURE__ */ Specular_FRP_Base.uniqDyn(monadFRP);
var asks = /* #__PURE__ */ Control_Monad_Reader_Class.asks(Specular_Dom_Builder.monadAskBuilder);
var holdUniqDynBy = /* #__PURE__ */ Specular_FRP_Base.holdUniqDynBy(monadFRP);
var eq = /* #__PURE__ */ Data_Eq.eq(Data_Eq.eqBoolean);
var voidRight = /* #__PURE__ */ Data_Functor.voidRight(Specular_FRP_Base.functorEvent);
var identity = /* #__PURE__ */ Control_Category.identity(Control_Category.categoryFn);
var map = /* #__PURE__ */ Data_Functor.map(Specular_Dom_Builder.functorBuilder);
var map1 = /* #__PURE__ */ Data_Functor.map(Specular_FRP_Base.functorDynamic);
var asyncRequest = /* #__PURE__ */ Specular_FRP_Async.asyncRequest(Specular_Dom_Builder.monadEffectBuilder)(monadFRP);
var $$delete = /* #__PURE__ */ Record["delete"]({
    reflectSymbol: function () {
        return "value";
    }
})()();
var for2 = /* #__PURE__ */ Control_Applicative_Extra.for2(Specular_FRP_Base.applyDynamic);
var apply = /* #__PURE__ */ Control_Apply.apply(Specular_FRP_Base.applyDynamic);
var union = /* #__PURE__ */ Record.union();
var dynamicFixFRP = /* #__PURE__ */ Utils_DynamicFixFRP.dynamicFixFRP(Utils_DynamicFixFRP.dynamicFixFRPDynamic)(monadFRP);
var composeKleisli = /* #__PURE__ */ Control_Bind.composeKleisli(Specular_Dom_Builder.bindBuilder);
var newRef = /* #__PURE__ */ Specular_Ref.newRef(Specular_Dom_Builder.monadEffectBuilder);
var map2 = /* #__PURE__ */ Data_Functor.map(Data_Functor.functorFn);
var conj = /* #__PURE__ */ Data_HeytingAlgebra.conj(Data_HeytingAlgebra.heytingAlgebraBoolean);
var lift2 = /* #__PURE__ */ Control_Apply.lift2(Specular_FRP_Base.applyDynamic);
var liftWidget = /* #__PURE__ */ Specular_Dom_Widget.liftWidget(Specular_Dom_Builder.monadDomBuilderBuilder);
var for_ = /* #__PURE__ */ Data_Foldable.for_(Specular_Dom_Builder.applicativeBuilder)(Data_Foldable.foldableArray);
var monadWidget = /* #__PURE__ */ Specular_Dom_Widget.monadWidget(Specular_Dom_Builder.monadDomBuilderBuilder)(monadFRP)(Specular_Dom_Builder.monadReplaceBuilder)(/* #__PURE__ */ Specular_Dom_Builder.monoidBuilder(Data_Monoid.monoidUnit));
var booleanInputView = /* #__PURE__ */ Specular_DeprecatedDontUse_Input.booleanInputView(monadWidget);
var append = /* #__PURE__ */ Data_Semigroup.append(/* #__PURE__ */ Foreign_Object.semigroupObject(Data_Semigroup.semigroupString));
var attr = /* #__PURE__ */ Specular_Extra_Attr.attr(Specular_Extra_Attr.attrStringAttrs);
var testId = /* #__PURE__ */ Specular_Dom_Extra.testId(Specular_Dom_Extra.testIdLegacyAdapterAttrs);
var attachEvent = /* #__PURE__ */ Specular_Callback.attachEvent()(monadFRP);
var refUpdateConst = /* #__PURE__ */ Specular_Ref.refUpdateConst(Effect_Class.monadEffectEffect);
var imap = /* #__PURE__ */ Data_Functor_Invariant.imap(Specular_Ref.invariantRef);
var $$new = /* #__PURE__ */ Specular_Ref["new"](Specular_Dom_Builder.monadEffectBuilder);
var textInput = /* #__PURE__ */ Specular_DeprecatedDontUse_Input.textInput(monadWidget);
var textInputValueOnChange = /* #__PURE__ */ Specular_DeprecatedDontUse_Input.textInputValueOnChange(monadFRP);
var attr1 = /* #__PURE__ */ Specular_Extra_Attr.attr(Specular_Extra_Attr.attrStringProp);
var checkbox = /* #__PURE__ */ Specular_DeprecatedDontUse_Input.checkbox(monadWidget);
var NotChanged = /* #__PURE__ */ (function () {
    function NotChanged() {

    };
    NotChanged.value = new NotChanged();
    return NotChanged;
})();
var Loading = /* #__PURE__ */ (function () {
    function Loading() {

    };
    Loading.value = new Loading();
    return Loading;
})();
var Success = /* #__PURE__ */ (function () {
    function Success() {

    };
    Success.value = new Success();
    return Success;
})();
var $$Error = /* #__PURE__ */ (function () {
    function $$Error(value0) {
        this.value0 = value0;
    };
    $$Error.create = function (value0) {
        return new $$Error(value0);
    };
    return $$Error;
})();
var ErrorText = /* #__PURE__ */ (function () {
    function ErrorText(value0) {
        this.value0 = value0;
    };
    ErrorText.create = function (value0) {
        return new ErrorText(value0);
    };
    return ErrorText;
})();
var ErrorRawHtml = /* #__PURE__ */ (function () {
    function ErrorRawHtml(value0) {
        this.value0 = value0;
    };
    ErrorRawHtml.create = function (value0) {
        return new ErrorRawHtml(value0);
    };
    return ErrorRawHtml;
})();
var textInputOnTouch = function (initialValue) {
    return function (attributes) {
        return bind(Specular_Dom_Element["el$prime"]("input")([ Specular_Dom_Element.attrs(attributes) ])(Restaumatic_Prelude_Specular.wempty))(function (v) {
            return discard1(liftEffect(Specular_Dom_Browser.setTextInputValue(v.value0)(initialValue)))(function () {
                return bind(newEvent)(function (domChanged) {
                    return discard1(onDomEvent("input")(v.value0)(function (v1) {
                        return function __do() {
                            liftEffect1(Specular_Dom_Browser.setTextInputValue(v.value0)(initialValue))();
                            return domChanged.fire(Data_Unit.unit)();
                        };
                    }))(function () {
                        return pure({
                            value: pure1(initialValue),
                            event: domChanged.event
                        });
                    });
                });
            });
        });
    };
};
var renderErrorString = {
    renderError: Specular_Dom_Element.text
};
var renderErrorErrorContent = {
    renderError: function (v) {
        if (v instanceof ErrorText) {
            return Specular_Dom_Element.text(v.value0);
        };
        if (v instanceof ErrorRawHtml) {
            return rawHtml(v.value0);
        };
        throw new Error("Failed pattern match at Restaumatic.OldForm (line 49, column 1 - line 51, column 43): " + [ v.constructor.name ]);
    }
};
var renderError = function (dict) {
    return dict.renderError;
};
var validationInfo = function (dictRenderError) {
    var renderError1 = renderError(dictRenderError);
    return function (validationState) {
        return Specular_Dom_Element.el("span")([ Specular_Dom_Element.class_("m-form__validation-info") ])(dynamic_(mapFlipped(validationState)(function (v) {
            if (v instanceof NotChanged) {
                return Restaumatic_Prelude_Specular.wempty;
            };
            if (v instanceof Loading) {
                return Restaumatic_Prelude_Specular.wempty;
            };
            if (v instanceof Success) {
                return Restaumatic_Prelude_Specular.wempty;
            };
            if (v instanceof $$Error) {
                return renderError1(v.value0);
            };
            throw new Error("Failed pattern match at Restaumatic.OldForm (line 93, column 36 - line 97, column 35): " + [ v.constructor.name ]);
        })));
    };
};
var validationInfo1 = /* #__PURE__ */ validationInfo(renderErrorString);
var formGroupClass = function (state) {
    return Specular_Dom_Element.classesD(mapFlipped(state)(function (v) {
        if (v instanceof NotChanged) {
            return [  ];
        };
        if (v instanceof Loading) {
            return [ "is-loading" ];
        };
        if (v instanceof Success) {
            return [ "success" ];
        };
        if (v instanceof $$Error) {
            return [ "has-error" ];
        };
        throw new Error("Failed pattern match at Restaumatic.OldForm (line 248, column 45 - line 252, column 29): " + [ v.constructor.name ]);
    }));
};
var group = function (validationState) {
    return Specular_Dom_Element.el("div")([ Specular_Dom_Element.class_("form-group m-form__group"), formGroupClass(validationState) ]);
};
var fieldWithValidation = function () {
    return function (dictEq) {
        var uniqDyn1 = uniqDyn(dictEq);
        return function (validate) {
            return function (view) {
                var toValidationState = function (v) {
                    if (v instanceof Specular_FRP_Async.Loaded) {
                        return v.value0;
                    };
                    if (v instanceof Specular_FRP_Async.Loading) {
                        return Loading.value;
                    };
                    if (v instanceof Specular_FRP_Async.NotRequested) {
                        return NotChanged.value;
                    };
                    throw new Error("Failed pattern match at Restaumatic.OldForm (line 307, column 5 - line 315, column 19): " + [ v.constructor.name ]);
                };
                var control = function (valueR) {
                    return bind(uniqDyn1(valueR.value))(function (valueD) {
                        return bind(asks(function (v) {
                            return v.forceShowValidationErrors;
                        }))(function (forceShowErrors) {
                            return bind(holdUniqDynBy(eq)(false)(Specular_FRP_Base.leftmost([ voidRight(true)(Specular_FRP_Base.changed(valueD)), Specular_FRP_Base.filterEvent(identity)(Specular_FRP_Base.changed(forceShowErrors)) ])))(function (hasChanged) {
                                return bind(map(map1(toValidationState))(asyncRequest(map1(validate)(valueR.value))))(function (validationState) {
                                    var valueRemainder = $$delete(Type_Proxy["Proxy"].value)(valueR);
                                    var validatedValue = for2(validationState)(valueR.value)(function (state) {
                                        return function (value$prime) {
                                            if (state instanceof Success) {
                                                return new Data_Maybe.Just(value$prime);
                                            };
                                            return Data_Maybe.Nothing.value;
                                        };
                                    });
                                    var displayedValidationState = apply(map1(function (v) {
                                        return function (v1) {
                                            if (v) {
                                                return v1;
                                            };
                                            return NotChanged.value;
                                        };
                                    })(hasChanged))(validationState);
                                    return pure(new Data_Tuple.Tuple(displayedValidationState, Data_Function.flip(union)(valueRemainder)({
                                        valid: validatedValue,
                                        raw: valueR.value
                                    })));
                                });
                            });
                        });
                    });
                };
                return dynamicFixFRP(NotChanged.value)(composeKleisli(view)(control));
            };
        };
    };
};
var eqValidationState = function (dictEq) {
    var eq1 = Data_Eq.eq(dictEq);
    return {
        eq: function (x) {
            return function (y) {
                if (x instanceof NotChanged && y instanceof NotChanged) {
                    return true;
                };
                if (x instanceof Loading && y instanceof Loading) {
                    return true;
                };
                if (x instanceof Success && y instanceof Success) {
                    return true;
                };
                if (x instanceof $$Error && y instanceof $$Error) {
                    return eq1(x.value0)(y.value0);
                };
                return false;
            };
        }
    };
};
var controlLabel = function (opts) {
    return Specular_Dom_Element.el("label")([ Specular_Dom_Element.class_("control-label m-form__label"), Specular_Dom_Element.classWhen(opts.required)("m-form__label--required"), Specular_Dom_Element.attr("for")(opts["for"]) ]);
};
var radioGroupFieldInitiallyEmpty = function (dictEq) {
    var eq1 = Data_Eq.eq(Data_Maybe.eqMaybe(dictEq));
    return function (config) {
        return function (fieldName) {
            return function (errorMessage) {
                return bind(newRef(config.initial))(function (selectedOption) {
                    return bind(asks(function (v) {
                        return v.forceShowValidationErrors;
                    }))(function (forceShowErrors) {
                        var hasError = map1(map2(function (v) {
                            return config.required && v;
                        })(Data_Maybe.isNothing))(Specular_Ref.refValue(selectedOption));
                        var showError = lift2(conj)(forceShowErrors)(hasError);
                        return discard1(liftWidget(Specular_Dom_Element.el("div")([ Specular_Dom_Element.class_("radio_buttons input form-group"), Specular_Dom_Element.classWhen(config.required)("required"), Specular_Dom_Element.classWhenD(showError)("has-error") ])(discard1(Specular_Dom_Element.el("span")([ Specular_Dom_Element.class_("form-label") ])(controlLabel({
                            required: config.required,
                            "for": ""
                        })(Specular_Dom_Element.text(config.label))))(function () {
                            return discard1(for_(config.options)(function (option) {
                                return Specular_Dom_Element.el("div")([ Specular_Dom_Element.class_("radio") ])(Specular_Dom_Element.el("label")([ Specular_Dom_Element.class_("choice m-radio") ])((function () {
                                    var isSelected = map1(eq1(new Data_Maybe.Just(option)))(Specular_Ref.refValue(selectedOption));
                                    return bind(booleanInputView(Specular_DeprecatedDontUse_Input.Radio.value)(isSelected)(pure1(append(attr("name")(fieldName))(append(attr("class")("m-radio__input"))(testId(config.testId(option)))))))(function (selectionChanged) {
                                        return discard1(Specular_Dom_Element.el("i")([ Specular_Dom_Element.class_("m-radio__icon-state") ])(Restaumatic_Prelude_Specular.wempty))(function () {
                                            return discard1(config.display(option)(selectedOption))(function () {
                                                return attachEvent(voidRight(new Data_Maybe.Just(option))(Specular_FRP_Base.filterEvent(identity)(selectionChanged)))(refUpdateConst(selectedOption));
                                            });
                                        });
                                    });
                                })()));
                            }))(function () {
                                return validationInfo1(mapFlipped(showError)(function (showError$prime) {
                                    if (showError$prime) {
                                        return new $$Error(errorMessage);
                                    };
                                    return NotChanged.value;
                                }));
                            });
                        }))))(function () {
                            return pure(Specular_Ref.refValue(selectedOption));
                        });
                    });
                });
            };
        };
    };
};
var textField = function (dictRenderError) {
    var validationInfo2 = validationInfo(dictRenderError);
    return function (v) {
        return group(v.validationState)(discard1(controlLabel({
            required: v.required,
            "for": v.name
        })(Specular_Dom_Element.text(v.label)))(function () {
            return bind(map(Data_Maybe.maybe(function (x) {
                return x;
            })(function (f) {
                return imap(f)(f);
            })(v.autoFormat))($$new(v.initialValue)))(function (valueRef) {
                return bind(Specular_Dom_Element.el("input")([ Specular_Dom_Element.attrs(append(attr("id")(v.name))(append(attr("class")("form-control u-text-normal"))(v.attrs))), Specular_Dom_Element.bindValueOnChange(valueRef) ])(Restaumatic_Prelude_Specular.wempty))(function () {
                    var value = Specular_Ref.value(valueRef);
                    return discard1(validationInfo2(v.validationState))(function () {
                        return pure({
                            value: value
                        });
                    });
                });
            });
        }));
    };
};
var textField$prime = function (dictRenderError) {
    var validationInfo2 = validationInfo(dictRenderError);
    return function (v) {
        return function (newValue) {
            return group(v.validationState)(discard1(controlLabel({
                required: v.required,
                "for": v.name
            })(Specular_Dom_Element.text(v.label)))(function () {
                var attrs$prime = pure1(append(attr("id")(v.name))(append(attr("class")("form-control u-text-normal"))(append(attr("name")(v.name))(v.attrs))));
                return bind(bind(textInput({
                    initialValue: v.initialValue,
                    attributes: attrs$prime,
                    setValue: newValue
                }))(function (input) {
                    return textInputValueOnChange(input);
                }))(function (value) {
                    return discard1(validationInfo2(v.validationState))(function () {
                        return pure({
                            value: value
                        });
                    });
                });
            }));
        };
    };
};
var textFieldLock = function (dictRenderError) {
    var validationInfo2 = validationInfo(dictRenderError);
    return function (v) {
        return group(v.validationState)(discard1(controlLabel({
            required: v.required,
            "for": v.name
        })(Specular_Dom_Element.text(v.label)))(function () {
            return bind(textInputOnTouch(v.initialValue)(append(attr("id")(v.name))(append(attr("class")("form-control u-text-normal"))(v.attrs))))(function (v1) {
                return discard1(validationInfo2(v.validationState))(function () {
                    return pure({
                        value: v1.value,
                        event: v1.event
                    });
                });
            });
        }));
    };
};
var checkboxFieldRef = function (dictRenderError) {
    var validationInfo2 = validationInfo(dictRenderError);
    return function (v) {
        return Specular_Dom_Element.el("div")([ Specular_Dom_Element.class_("boolean input checkbox form-group"), formGroupClass(v.validationState) ])(Specular_Dom_Element.el("span")([ Specular_Dom_Element.class_("form-wrapper") ])(discard1(Specular_Dom_Element.el("label")([ Specular_Dom_Element.class_("m-checkbox"), Specular_Dom_Element.classWhen(v.required)("m-form__label--required") ])(discard1(Specular_Dom_Element.el("input")([ attr1("type")("checkbox"), Specular_Dom_Element.class_("m-checkbox__input"), Specular_Dom_Element.attrsD(v.attrs), Specular_Dom_Element.bindChecked(v.value) ])(Restaumatic_Prelude_Specular.wempty))(function () {
            return discard1(Specular_Dom_Element.el("i")([ Specular_Dom_Element.class_("m-checkbox__icon-state") ])(Restaumatic_Prelude_Specular.wempty))(function () {
                return v.label;
            });
        })))(function () {
            return validationInfo2(v.validationState);
        })));
    };
};
var checkboxField = function (dictRenderError) {
    var validationInfo2 = validationInfo(dictRenderError);
    return function (v) {
        return Specular_Dom_Element.el("div")([ Specular_Dom_Element.class_("boolean input checkbox form-group"), formGroupClass(v.validationState) ])(Specular_Dom_Element.el("span")([ Specular_Dom_Element.class_("form-wrapper") ])(bind(Specular_Dom_Element.el("label")([ Specular_Dom_Element.class_("m-checkbox"), Specular_Dom_Element.classWhen(v.required)("m-form__label--required") ])(bind(checkbox(v.initialValue)(append(attr("class")("m-checkbox__input"))(v.attrs)))(function (value) {
            return discard1(Specular_Dom_Element.el("i")([ Specular_Dom_Element.class_("m-checkbox__icon-state") ])(Restaumatic_Prelude_Specular.wempty))(function () {
                return discard1(v.label)(function () {
                    return pure(value);
                });
            });
        })))(function (value) {
            return discard1(validationInfo2(v.validationState))(function () {
                return pure({
                    value: value
                });
            });
        })));
    };
};
export {
    NotChanged,
    Loading,
    Success,
    $$Error as Error,
    ErrorText,
    ErrorRawHtml,
    renderError,
    textField,
    textField$prime,
    textFieldLock,
    checkboxField,
    checkboxFieldRef,
    radioGroupFieldInitiallyEmpty,
    group,
    fieldWithValidation,
    eqValidationState,
    renderErrorString,
    renderErrorErrorContent
};
